/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

const state = {
  // add/edit ticket data
  ticketData: {
    id: null,
    name: {
      en: null,
      et: null,
      ru: null,
    },
    description: {
      en: null,
      et: null,
      ru: null,
    },
    price_rule_type: null,
    available_amount: 0,
    time_cost: null,
    unit_type: null,
    unit_price: null,
    id_code_enabled: null,
    icon: null,
  },
  ticketsList: [],
  errors: {},
  kioskId: null,
  tabLang: "en"
}

const getters = {
  ticketData: state => state.ticketData,
  filedErrors: state => state.errors,
  ticketsList: state => state.ticketsList,
  kioskId: state => state.kioskId,
  tabLang: state => state.tabLang
}

const actions = {
  storeData({ commit }, payload) {
    commit('storeData', payload)
  },
  addError({ commit }, payload) {
    commit('setError', payload)
  },
  setToList({ commit }, payload) {
    commit('setToList', payload)
  },
  setKioskId({ commit }, payload) {
    commit('setKioskId', payload)
  },
  clear({ commit }, payload) {
    commit('clearState')
  },
  excludeItem({ commit }, payload) {
    commit('excludeItem', payload)
  },
  setTabLang({ commit }, payload) {
    commit('setTabLang', payload)
  },
  storeName({ commit }, payload) {
    commit('setName', payload)
  },
  storeDescription({ commit }, payload) {
    commit('setDescription', payload)
  }
}

const mutations = {
  ['storeData'](state, data) {
    state.ticketData[data.field] = data.value
  },
  ['setError'](state, data) {
    state.errors[data.field] = true
  },
  ['setToList'](state, data) {
    state.ticketsList.push(data)
  },
  ['setKioskId'](state, data) {
    state.kioskId = data.kioskId
  },
  ['clearState'](state) {
    state.errors = []
    state.ticketsList = []
  },
  ['excludeItem'](state, id) {
    state.ticketsList = state.ticketsList.filter(item => item.id !== id)
  },
  ['setTabLang'](state, data) {
    state.tabLang = data.lang
  },
  ['setName'](state, data) {
    state.ticketData.name[data.lang] = data.name
  },
  ['setDescription'](state, data) {
    if (state.ticketData.description.length === 0) {
      state.ticketData.description = {
        en: null,
        et: null,
        ru: null
      }
    }
    state.ticketData.description[data.lang] = data.description
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/tenants/ticketTypes.js